import {Collections, VarSheetType} from '@ozark/common';
import {
  EquipmentView,
  EquipmentViewableBy,
  hasErpRole,
  UserRoles,
} from '@ozark/functions/src/shared';
import {useEffect, useState} from 'react';
import {Firebase} from '../../../firebase';
import {AsyncState} from '../../../hooks/AsyncState';

export const useViewableEquipment = (role?: UserRoles) => {
  const [equipment, setEquipment] = useState<AsyncState<EquipmentView[]>>({promised: true});

  const isErpUser = hasErpRole(role);
  const isAgent = role === UserRoles.agent;
  const isMerchant = role === UserRoles.merchant;

  useEffect(() => {
    const collectionRef = Firebase.firestore.collection(Collections.equipment);
    let baseQuery = collectionRef.where(
      'varSheetType',
      'in',
      Object.values(VarSheetType).filter(type => type !== VarSheetType.na)
    );

    if (isErpUser || isAgent) {
      baseQuery = baseQuery.where('viewableBy', 'in', [
        EquipmentViewableBy.all,
        EquipmentViewableBy.agent,
      ]);
    } else if (isMerchant) {
      baseQuery = baseQuery.where('viewableBy', 'in', [
        EquipmentViewableBy.all,
        EquipmentViewableBy.merchant,
      ]);
    } else {
      baseQuery = baseQuery.where('viewableBy', 'in', [EquipmentViewableBy.all]);
    }

    return baseQuery.onSnapshot(
      snapshot => {
        const data = snapshot.docs
          .map(
            doc =>
              ({
                id: doc.id,
                ref: doc,
                ...doc.data(),
              } as EquipmentView)
          )
          .sort((a, b) => a.name.localeCompare(b.name));
        setEquipment({
          promised: false,
          data,
        });
      },
      err => {
        setEquipment({promised: false, error: err});
      }
    );
  }, [setEquipment, role]);

  return {equipment};
};
